import { Controller } from "@hotwired/stimulus"

// Optional behaviour for the FAQ accordion. <details> elements already work
// without JS, but this lets us collapse siblings when one opens, for a more
// polished UX.
export default class extends Controller {
  static targets = ["item"]

  initialize() {
    this.itemTargets.forEach((item) => {
      item.addEventListener("toggle", () => {
        if (item.open) {
          this.itemTargets.forEach((other) => {
            if (other !== item) other.open = false
          })
        }
      })
    })
  }
}
